var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPln(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130.00 130.00",
    enableBackground: "new 0 0 130 120",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Infos"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    x: -1850,
    y: -880,
    fill: "#DB3A49",
    width: 2180,
    height: 1700
  })), /*#__PURE__*/React.createElement("g", {
    id: "Others"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Europe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 60,
    fill: "#DB3A49",
    width: 130,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    width: 130,
    height: 60
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPln);
export default __webpack_public_path__ + "static/media/PLN.90ae5124b92880ff41ece6cdbff61833.svg";
export { ForwardRef as ReactComponent };